import React, {useEffect, useState} from "react";
import TemplatesSearch from "./TemplatesSearch";
import TemplateCategory from "./TemplateCategory";
import {generateMenuFromTemplatesList} from "../../../../../utils/SurveyUtils";
import { Link } from "react-router-dom";

export const CategoryCollapse = Object.freeze({
    COLLAPSED: 'COLLAPSED',
    EXPANDED: 'EXPANDED',
    DEFAULT: 'DEFAULT'
});

function TemplatesMenu(props) {
    const {
        isInSearch,
        setSearchTemplates,
        setIsInSearch,
        searchTemplates,
        allTemplates,
        fetchSearchTemplatesList,
        selectedTemplateId,
        isMobile
    } = props;
    const resultsAreFound = searchTemplates.length > 0;

    const [categoriesCollapse, setCategoriesCollapse] = useState(CategoryCollapse.DEFAULT);

    useEffect(() => {
        if (isMobile) {
            setCategoriesCollapse(CategoryCollapse.EXPANDED)
        }
    }, [searchTemplates]);

    const filterTemplatesByCategory = (categoryName) => {
        const filteredTemplates = allTemplates.filter((template) => template.category.categoryName === categoryName);
        setSearchTemplates(filteredTemplates);
    }

    const menuItems = (templates) => {
        const templatesMenu = generateMenuFromTemplatesList(templates);

        if (templatesMenu) {
            return templatesMenu.map(templateCategory =>
                <TemplateCategory
                    key={templateCategory.categoryId}
                    templateCategory={templateCategory}
                    filterTemplatesByCategory={filterTemplatesByCategory}
                    categoriesCollapse={categoriesCollapse}
                    selectedTemplateIdx={templateCategory.templatesList.findIndex(template => template.questId == selectedTemplateId)}
                    isMobile={isMobile} />)
        } else return [];
    }

    const renderingMenuTemplates = isMobile
        ? (resultsAreFound ? searchTemplates : allTemplates)
        : allTemplates;
    return (
        <>
            { resultsAreFound && <div className="template__title">Choose from our list of survey templates</div> }
            <div className="template__menu">
                {!isMobile && <TemplatesSearch
                    fetchSearchTemplatesList={fetchSearchTemplatesList}
                    setSearchTemplates={setSearchTemplates}
                    isInSearch={isInSearch}
                    setIsInSearch={setIsInSearch}/>}
                { (isMobile && isInSearch && !resultsAreFound) &&
                    <p className="template__not_found_mobile">We could not find what you're looking for. Please check our available survey templates below:</p> }
                <ul className="template__menu__list list">
                    <li className="list__item list__item--default"><Link to="/survey-templates" onClick={() => {fetchSearchTemplatesList()}}>All templates</Link></li>
                    {menuItems(renderingMenuTemplates)}
                </ul>
            </div>
        </>
    );
}

export default TemplatesMenu;